import apiClient from "./apiClient";
import { HubRequest, HubResult, HubSearch} from "hubs/models";
import { Hub } from "common/models";
import { PagedResults } from "common/models";

const searchHubs = async (search: HubSearch | null): Promise<PagedResults<Hub>> => {
  let uri = "/hubs/search";
  var query: string[] = [];
  if (search?.name) query.push(`name=${search.name}`);
  if (search?.rcxLocId) query.push(`rcxLocId=${search.rcxLocId}`);
  if(search?.isActive !== 'all') query.push(`isActive=${search?.isActive === 'active'? true : false}`);
  query.push(`offset=${search?.pagedSearchOptions.offset}`);
  query.push(`pageSize=${search?.pagedSearchOptions.pageSize}`);
  query.push(`sortName=${search?.sortName}`);
  query.push(`sortAsc=${search?.sortAsc}`);
  if (query.length > 0) uri = `${uri}?${query.join("&")}`;

  return apiClient.get(uri);
};

const getHub = async (id: number): Promise<HubResult> => {
  let uri = `/hubs/${id}`;
  return apiClient.get(uri);
};

const updateHub = async (request: HubRequest): Promise<any> =>{
  return apiClient.put(`/hubs/${request.id}`, request);
}

const addClientToHub = async (id:number, clientId: number, clientHubName?: string): Promise<any> =>{
  return apiClient.post(`/hubs/${id}/client`, { clientId, clientHubName });
}

const removeClientFromHub = async (id:number, clientId: number): Promise<any> =>{
  return apiClient.remove(`/hubs/${id}/client/${clientId}`,{});
}

const hubsService = {
  searchHubs,
  getHub,
  updateHub,
  addClientToHub,
  removeClientFromHub
};

export default hubsService;